import React from "react";


import {
    Col
} from "react-bootstrap";


import "./index.scss";


export const DividerElementComponent = () => {
    return (
        <Col xs={12} className={'divider-element-component'}></Col>
    );
};


export default DividerElementComponent;
